<template>
  <nav v-if="links" class="navbar navbar-light bg-light nav-top">
    <div class="container-fluid">
      <router-link class="link home" to="/">Home</router-link> 
      <router-link class="link" v-for="link in links" v-bind:to="link.href" v-bind:key="link.id" v-bind:id="link.href">
        {{link.label}}
    </router-link>
    </div>
  </nav>
</template>

<script>

export default {
  name: 'TopNavbar',
  props: {
    links:Array
  },
  mounted(){
    this.setLinkHover();
  },
  methods:{
    setLinkHover(){
      let self = this;
      this.links.forEach(function(link){
        var elem = document.querySelector("#" + link.href);
        elem.addEventListener('mouseover',function(){
          elem.style.backgroundColor = link.color;
        })
        elem.addEventListener('mouseout',function(){
          var page = self.$route.params.mappage;
          if (page == link.href){
            elem.style.backgroundColor = link.color;
          }
          else{
            elem.style.backgroundColor = "";
          }
        })
      })
    }
  }
}
</script>

<style>
    .navbar{
        padding-top:0;
        padding-bottom:0;
    }
    .link:hover{
      color:white !important;
    }
    .link{
      font-size:18px;
    }
    .home:hover{
      background:#C41E3A !important;
    }
</style>
